import React, { FunctionComponent, ReactNode, useEffect, useRef } from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useDisclosure
} from '@chakra-ui/react';

export const AppAlertDialog: FunctionComponent<{
  title?: string;
  alert?: string;
  open?: boolean;
  onClose?: () => void;
  children?: ReactNode;
  mode?: 'message' | 'confirm';
}> = ({ title, alert, open, children, onClose, mode = 'confirm' }) => {
  const { isOpen, onOpen, onClose: chakraOnClose } = useDisclosure();
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  useEffect(() => {
    if (open) {
      onOpen();
    } else {
      chakraOnClose();
    }
  }, [open, onOpen, chakraOnClose]);

  const handleClose = () => {
    chakraOnClose();
    if (onClose) {
      onClose();
    }
  };

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={buttonRef}
      onClose={handleClose}
      isOpen={isOpen}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      isCentered>
      <AlertDialogOverlay />
      <AlertDialogContent>
        {title && <AlertDialogHeader>{title}</AlertDialogHeader>}
        {mode === 'confirm' && <AlertDialogCloseButton />}
        <AlertDialogBody>{children ? children : alert}</AlertDialogBody>
        {mode === 'confirm' && (
          <AlertDialogFooter>
            <Button ref={buttonRef} onClick={handleClose} colorScheme="orange">
              Sluiten
            </Button>
          </AlertDialogFooter>
        )}
      </AlertDialogContent>
    </AlertDialog>
  );
};
